<template>
  <div class="container bigger-top-margin">
    <div class="row justify-content-center">
      <div class="col">
        <div class="card card-default">
          <div class="card-header">The story</div>

          <div class="card-body">
            Eleven years ago I started working as a freelancer. The journey from that day to today contributed to the creation of the Expense Guide app, a personal finance management app.<br>
            <br>
            Before we delve into the story, I'd like to share with you my philosophy about money. For me, money is a tool that temporarily stores relative value and gives you the possibility to exchange that value for something that you need or desire as part of your lifestyle. To make money, you have to create value for someone. I don’t perceive money as good, nor evil — it’s just an abstract thing that we, humans, believe in.<br>
            <br>
            As a freelancer, I don't have a fixed stream of income every month, so planning my (and my family’s) expenses can get a bit tricky. To fix this, I started writing down my spendings and estimating my future expenses. By doing that, I could foresee months ahead the approximate amount of money I would need to maintain my current lifestyle, and then act accordingly as a result.<br>
            <br>
            <b>I found out that, for me, it's healthier to plan the future than to think about the past.</b><br>
            <br>
            So, with that in mind, I created this app! It has a clean and minimal design, it’s easy to use, and it provides just enough info to help you manage your finances responsibly. No fancy graphs, no predefined categories or irrelevant details! Just a simple list of current & upcoming expenses, and 5 numbers of great importance in my book.<br>
            <br>
            These 5 numbers are:

            <ul>
              <li>average monthly spending</li>
              <li>average monthly unexpected spending</li>
              <li>average future monthly spending</li>
              <li>minimal safety net amount (for 6 months)</li>
              <li>optimal safety net amount (for 12 months)</li>
            </ul>
            <br>
            Using Elizabeth Warren’s <b>50/30/20</b> rule of thumb for budgeting, and allocating 50% of your income on needs, 30% on wants, and 20% on savings — you could build your minimal safety net in 24 months and the optimal safety net in 48 months. Think about the peace of mind that will bring you!<br>
            <br>
            And because I value privacy, and "keeping it simple” is a little mantra of mine, this also translates into this app as:
            <ul>
              <li>No income data required — <i>besides being too personal, it would also imply for you to be truly diligent with tracking everything, in order to make sure the 'available funds' amounts is kept accurate at all times… and I want to make your life easier with this app, not stress you out!</i></li>
              <li>No credit card transactions processed</li>
              <li>No tracking</li>
              <li>No ads — <i>in-app ads annoy me, too!</i></li>
              <li>No reminder emails — <i>at least not for now! But I’m not completely rejecting the idea, in case there will be requests from users about this feature.</i></li>
              <li>No decimal numbers — <i>I believe that a personal finance app will never reflect 100% a person's spendings down by every penny, so it’s safe to assume that we could simply enter a $15 amount (round up) for a $14.20 purchase.</i></li>
            </ul>
            <br>
            If you made it this far, and the only question you have is:<br>
            <i>“Well, I’m not a freelancer like you! Can I still get use out of this app?”…</i> then, it’s perfect!<br>
            It means you’re ready to start planning your expenses — because, YES, Expense Guide is suitable for everyone, regardless if you have a fluctuating stream of income or a fixed & very predictable one.<br>
            <br>
            So, let’s get to it! There’s no better day to start something than today… and no better moment than right now!<br>
            <br><br>
          </div>
          <div class="floating-bottom-container"><button onclick="window.history.back()" class="btn btn-primary floating-bottom-right">Go Back</button></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheStory',
  data () {
    return {}
  }
}
</script>
